import { api } from '../api';
import { Institution } from '../../entities/Institution';

/**
 * `GET /institutions/{id}` nasceu na tarefa 0.13 do roadmap B2G, junto com o `PUT`:
 * até então o módulo era **write-once** no back, e esta tela de edição existia sem
 * rota e sem API que a atendesse.
 */
export const getInstitution = async (id: string): Promise<Institution> => {
  const { data } = await api.get<Institution>(`/institutions/${id}`);

  return data;
};
